import { getParamsByPrefix } from "api-client/utils/get-params-by-prefix";

export function plainSearchParams(data: URLSearchParams, prefix?: string) {
  return getParamsByPrefix(prefix ?? null, data);
}
